"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var polished_1 = require("polished");
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("../../Themes/styled-components"));
var Wrapper = styled_components_1.default('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  z-index: 6;\n  max-height: ", ";\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  width: 100%;\n  top: 100%;\n  left: 0;\n  right: 0;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  ", "\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  z-index: 6;\n  max-height: ", ";\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  width: 100%;\n  top: 100%;\n  left: 0;\n  right: 0;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  ",
    "\n  ",
    "\n"])), polished_1.rem(300), function (_a) {
    var theme = _a.theme;
    return theme.separatorColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.largeBorderRadius;
}, function (_a) {
    var down = _a.down;
    return !down && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      top: auto;\n      bottom: 100%;\n    "], ["\n      top: auto;\n      bottom: 100%;\n    "])));
}, function (_a) {
    var hidden = _a.hidden;
    return hidden && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      visibility: hidden;\n    "], ["\n      visibility: hidden;\n    "])));
});
function isWholeElementVisible(elm) {
    var rect = elm.getBoundingClientRect();
    var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    return !(rect.top < 0 || rect.bottom - viewHeight >= 0);
}
exports.default = React.forwardRef(function (props, ref) {
    var _a = React.useState(true), resolvingPosition = _a[0], setResolvingPosition = _a[1];
    var _b = React.useState(true), isExpandingDownward = _b[0], setIsExpandingDownward = _b[1];
    var wrapperEl = React.useRef(null);
    React.useEffect(function () {
        if (wrapperEl && wrapperEl.current) {
            setIsExpandingDownward(isWholeElementVisible(wrapperEl.current));
            setResolvingPosition(false);
        }
    }, []);
    return (React.createElement(Wrapper, { down: isExpandingDownward, hidden: resolvingPosition, ref: function (e) {
            ref.current = e;
            wrapperEl.current = e;
        } }, props.children));
});
var templateObject_1, templateObject_2, templateObject_3;
